const privacyItems = [
  { title: '1.個人情報の定義', content: '個人情報とは、氏名、住所、電話番号、メールアドレスなど、特定の個人を識別できる情報をいいます。また、他の情報と組み合わせることで個人を識別できる情報も含まれます。' },
  { title: '2.個人情報の収集方法', content: '当社は、適法かつ公正な手段によって、お客様から個人情報を収集します。収集する個人情報は、利用目的を明確にした上で必要な範囲に限ります。' },
  { title: '3.個人情報の利用目的', content: '当社が収集した個人情報は、以下の目的で利用いたします。\n・サービス提供やアフターサポートのため\n・お問い合わせへの対応およびご案内のため\n・法令に基づく情報提供を行うため' },
  { title: '4.個人情報の第三者提供', content: '当社は、あらかじめお客様の同意を得た場合または法令に基づく場合を除き、第三者に個人情報を提供することはありません。ただし、業務委託先などに必要な範囲で提供する場合があります。' },
  { title: '5.個人情報の安全管理', content: '当社は、個人情報への不正アクセス、紛失、破壊、改ざんおよび漏洩を防止するため、必要かつ適切なセキュリティ対策を実施いたします。' },
  { title: '6.個人情報の開示・訂正・削除', content: 'お客様からご自身の個人情報の開示、訂正、追加、削除、利用停止のご依頼があった場合、法令に基づき適切に対応いたします。' },
  { title: '7.クッキー（Cookie）について', content: '当社のウェブサイトでは、お客様の利便性向上や利用状況の分析のためにクッキーを利用する場合があります。お客様がブラウザの設定によりクッキーの受け入れを拒否した場合、サービスの一部がご利用できない場合があります。' },
  { title: '8.プライバシーポリシーの変更', content: '当社は、法令の変更等に伴い、プライバシーポリシーを随時見直し、改訂することがあります。変更内容については、当社のウェブサイトにて速やかに公表いたします。' },
];

const PrivacySection = () => (
  <section id="privacy" className="py-20 bg-[#f7f9f7]">
    <div className="max-w-4xl mx-auto px-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">プライバシーポリシー</h2>
      <p className="text-xs text-gray-500 leading-relaxed mb-8">
        株式会社atco（以下「当社」といいます）は、お客様の個人情報の保護を重要な責務と認識し、以下の通りプライバシーポリシーを定め、その適切な取り扱いと保護に努めてまいります。
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {privacyItems.map((item) => (
          <div key={item.title} className="bg-white rounded-lg p-5 border border-gray-100">
            <h3 className="text-xs font-bold text-gray-800 mb-2">{item.title}</h3>
            <p className="text-xs text-gray-500 leading-relaxed whitespace-pre-line">{item.content}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PrivacySection;
